<template>
  <Content title="我们的服务" class="bg-white">
    <div class="d-flex flex-wrap our-service">
      <div
        v-for="(service, i) in services"
        :key="i"
        class="service-item w-50 th-px-42 th-py-47 d-flex"
      >
        <div class="service-icon-wrapper">
          <img width="48" :src="service.image" alt="#" />
        </div>
        <div>
          <div class="th-fs-28">{{ service.title }}</div>
          <div class="th-fs-18 th-mt-12">{{ service.desc }}</div>
        </div>
      </div>
    </div>
  </Content>
</template>
<script>
import Content from '@/shared/components/content.vue'
import { services } from './data'
export default {
  name: 'DesktopService',
  components: { Content },
  setup() {
    return { services }
  },
}
</script>

<style lang="scss" scoped>
.service-item:hover {
  background-color: #4b7ef6;
  color: #fff;

  .service-icon-wrapper {
    background-color: #fff;
  }
}

.service-icon-wrapper {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  border: 5px solid rgba(205, 219, 255, 0.5);
  flex: none;
  text-align: center;
  margin-right: 40px;
}

.service-icon-wrapper img {
  top: 50%;
  transform: translateY(-50%);
  position: relative;
}
</style>
